import type { ObbTakeoffData } from './obbTakeoff';

export const KIMBARK_FIREPLACE_TAKEOFF: ObbTakeoffData = {
  title: 'Fireplace Takeoff',
  subtitle: 'Ground Floor · Living Room',
  elementLabel: 'Fireplace Surround',
  elementDimensions: "5' 7\" W × 4' 4\" H",
  scanLabel: 'Scene 3 aligned',
  color: '#f97316',

  // Raw Z-up coords (scene-3 frame). ObbTakeoffOverlay applies SPLAT_QUATERNION.
  // P0-P3 = extruded back face (0.2 m behind visible surface along face normal)
  // P4-P7 = actual visible face → fill highlights the surround surface
  obbPoints: [
    [-5.9876, -3.3408, -0.0995],  // P0 back-TL
    [-5.3976, -1.7408, -0.0995],  // P1 back-TR
    [-5.9876, -3.3308, -1.4195],  // P2 back-BL
    [-5.3776, -1.7208, -1.3795],  // P3 back-BR
    [-5.8000, -3.4100, -0.1000],  // P4 face-TL
    [-5.2100, -1.8100, -0.1000],  // P5 face-TR
    [-5.8000, -3.4000, -1.4200],  // P6 face-BL
    [-5.1900, -1.7900, -1.3800],  // P7 face-BR
  ],

  dimensionAnchors: {
    a: { point: [-5.505, -2.610,  0.150], label: "5' 7\"" },   // width along top
    b: { point: [-5.096, -1.519, -0.740], label: "4' 4\"" },   // height right side
    c: { point: [-5.265, -2.689, -0.751], label: '24 sq ft' }, // center area label
  },

  // Living-room viewpoint (computed — no kimbarkRooms entry for fireplace)
  cameraPos:  [-3.154, -0.057,  3.467],
  cameraLookAt: [-5.500, -0.750,  2.603],

  items: [
    { label: 'Surround stone / tile', modelQty: 17,  unit: 'sq ft',  wastePercent: 10 },
    { label: 'Mantle shelf',          modelQty: 5.6, unit: 'lin ft', wastePercent:  5 },
    { label: 'Firebox unit',          modelQty: 1,   unit: 'ea',     wastePercent:  0 },
    { label: 'Gas connection',        modelQty: 1,   unit: 'ea',     wastePercent:  0 },
  ],
};
